import { useState, useEffect, useRef } from 'react';
import api from '../../api';
import stili from './stili';
import ConflittoVersione, { eConflitto } from '../ConflittoVersione';

// Nuova dicitura o modifica: testo con variabili, categoria, automatica GIS e causale per ciascun fatturante
export default function FormDicitura({ dicitura, testoIniziale = '', fatturanti, onChiudi, onSalvato }) {
  const daDicitura = d => ({
    testo: d?.testo || testoIniziale,
    categoria: d?.categoria || '',
    automatica_gis: Boolean(d?.automatica_gis),
    attiva: d ? d.attiva : true,
    version: d?.version,
    causali: Object.fromEntries(fatturanti.filter(f => f.attivo || d?.causali?.[f.id]).map(f => [f.id, d?.causali?.[f.id] || ''])),
  });
  const [form, setForm] = useState(daDicitura(dicitura));
  const [causali, setCausali] = useState({});
  const [errore, setErrore] = useState('');
  const [salvataggio, setSalvataggio] = useState(false);
  const occupato = useRef(false);   // doppio clic: lo stato React si aggiorna solo al ridisegno
  const [conflitto, setConflitto] = useState(null);

  useEffect(() => {
    Promise.all(fatturanti.map(f => api.get('/competenze/causali', { params: { fatturante_id: f.id } }).then(r => [f.id, r.data])))
      .then(coppie => setCausali(Object.fromEntries(coppie)))
      .catch(() => {});
  }, [fatturanti]);

  const salva = async (version) => {
    setErrore('');
    if (occupato.current) return;
    occupato.current = true;
    setSalvataggio(true);
    try {
      const res = dicitura
        ? await api.put(`/competenze/diciture/${dicitura.id}`, { ...form, version })
        : await api.post('/competenze/diciture', form);
      setConflitto(null);
      onSalvato(res.data);
    } catch (err) {
      if (eConflitto(err)) setConflitto(err.response.data);
      else setErrore(err.response?.data?.errore || 'Errore nel salvataggio');
    } finally {
      occupato.current = false; setSalvataggio(false);
    }
  };

  return (
    <div style={stili.overlay}>
      <div style={{ ...stili.modal, maxWidth: '720px' }}>
        <h3 style={{ marginTop: 0 }}>{dicitura ? 'Modifica dicitura' : 'Nuova dicitura'}</h3>
        <form onSubmit={e => { e.preventDefault(); salva(form.version); }}>
          {errore && <div style={stili.errore}>{errore}</div>}
          <div style={stili.campo}>
            <label style={stili.label}>Testo</label>
            <input autoFocus value={form.testo} onChange={e => setForm(f => ({ ...f, testo: e.target.value }))} required maxLength={500} style={stili.input} />
            <small style={{ color: '#888' }}>Variabili disponibili: {'{lavoratore}'}, {'{numero}'}, {'{periodo}'}, {'{tipo_f24}'} (scelta dall'elenco Tipo F24). Es. "Assunzione {'{lavoratore}'}".</small>
          </div>
          <div style={stili.row}>
            <div style={stili.campo}>
              <label style={stili.label}>Categoria</label>
              <input value={form.categoria} onChange={e => setForm(f => ({ ...f, categoria: e.target.value }))} style={stili.input} />
            </div>
          </div>
          <label style={{ fontSize: '0.88rem', display: 'flex', gap: '0.4rem', alignItems: 'center', marginBottom: '0.4rem' }}>
            <input type="checkbox" checked={form.automatica_gis} onChange={e => setForm(f => ({ ...f, automatica_gis: e.target.checked }))} />
            Già addebitata in automatico da GIS (si registra, ma non va nel file per GIS)
          </label>
          {dicitura && (
            <label style={{ fontSize: '0.88rem', display: 'flex', gap: '0.4rem', alignItems: 'center' }}>
              <input type="checkbox" checked={form.attiva} onChange={e => setForm(f => ({ ...f, attiva: e.target.checked }))} />
              Attiva (se tolta, non compare più tra le scelte)
            </label>
          )}
          <h4 style={{ margin: '1rem 0 0.5rem' }}>Causale GIS per fatturante</h4>
          {fatturanti.filter(f => f.attivo || dicitura?.causali?.[f.id]).map(f => (
            <div key={f.id} style={stili.campo}>
              <label style={stili.label}>{f.nome}</label>
              <select
                value={form.causali[f.id]}
                onChange={e => setForm(x => ({ ...x, causali: { ...x.causali, [f.id]: e.target.value } }))}
                style={stili.input}
                aria-label={`Causale ${f.nome}`}
              >
                <option value="">— Nessuna —</option>
                {(causali[f.id] || []).map(c => <option key={c.codice} value={c.codice}>{c.codice} · {c.descrizione}</option>)}
              </select>
            </div>
          ))}
          <div style={stili.azioni}>
            <button type="button" onClick={onChiudi} style={stili.btnSecondary}>Annulla</button>
            <button type="submit" disabled={salvataggio} style={stili.btn}>{salvataggio ? 'Salvataggio…' : 'Salva'}</button>
          </div>
        </form>
      </div>
      {conflitto && (
        <ConflittoVersione
          conflitto={conflitto}
          inCorso={salvataggio}
          onRicarica={async () => {
            const r = await api.get('/competenze/diciture', { params: { tutte: 1 } });
            setForm(daDicitura(r.data.find(d => d.id === dicitura.id) || conflitto.attuale));
            setConflitto(null);
          }}
          onSovrascrivi={() => salva(conflitto.attuale.version)}
        />
      )}
    </div>
  );
}
